// Pure geo/number helpers for the home map route, extracted from HomePage.js.
// These are side-effect free and unit-tested in homeMapGeo.test.js.

export function toFiniteNumber(value) {
  if (typeof value === "string" && value.trim() === "") return null;
  if (value == null) return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function getUsableMapLatLng(latValue, lngValue) {
  const lat = toFiniteNumber(latValue);
  const lng = toFiniteNumber(lngValue);
  if (lat == null || lng == null) return null;
  if (lat === 0 && lng === 0) return null;
  return { lat, lng };
}

export function getRouteDestination(capsule) {
  if (!capsule || typeof capsule !== "object") return null;

  const position = capsule.position;
  const positionDestination = getUsableMapLatLng(position?.lat, position?.lng);
  if (positionDestination) return positionDestination;

  const location = capsule.location;
  const locationDestination = getUsableMapLatLng(location?.lat, location?.lng);
  if (locationDestination) return locationDestination;

  const capsuleDestination = getUsableMapLatLng(capsule.lat, capsule.lng);
  if (capsuleDestination) return capsuleDestination;

  return null;
}

export function distanceMeters(a, b) {
  if (!a || !b) return Number.POSITIVE_INFINITY;
  const toRad = (d) => (d * Math.PI) / 180;
  const R = 6371000;
  const dLat = toRad((b.lat || 0) - (a.lat || 0));
  const dLng = toRad((b.lng || 0) - (a.lng || 0));
  const lat1 = toRad(a.lat || 0);
  const lat2 = toRad(b.lat || 0);

  const h =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  return R * c;
}

export function buildOfferCenterKey(center) {
  const lat = Number(center?.lat);
  const lng = Number(center?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return "";
  return `${lat.toFixed(5)},${lng.toFixed(5)}`;
}

// Snap a map center onto a coarse grid so tiny pans (and iOS momentum/idle
// jitter) don't churn the nearby-discovery center key. Nearby gems/offers are
// queried within a multi-km radius, so a sub-cell nudge does not change which
// results are relevant. Keeping the snapped center stable prevents the gems
// button from disappearing on every small map movement.
export function snapCenterToGrid(center, stepDegrees = 0.02) {
  const lat = Number(center?.lat);
  const lng = Number(center?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  const step = Number(stepDegrees) > 0 ? Number(stepDegrees) : 0.02;
  return {
    lat: Math.round(lat / step) * step,
    lng: Math.round(lng / step) * step,
  };
}
